import { render } from "./ClickableIcon.vue?vue&type=template&id=51825eb0&scoped=true"
import script from "./ClickableIcon.vue?vue&type=script&lang=js"
export * from "./ClickableIcon.vue?vue&type=script&lang=js"

import "./ClickableIcon.vue?vue&type=style&index=0&id=51825eb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51825eb0"]])

export default __exports__